
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/request-price",
      function () {
        return require("private-next-pages/request-price.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/request-price"])
      });
    }
  